import { z } from "zod";
/**
 * O tour de primeiro uso (ADR 041), como ele atravessa a fronteira HTTP.
 *
 * `passo` é o índice do passo em curso na lista do navegador, e -1 é tour
 * parado. `concluido` só liga ao pular ou terminar: é o que impede o tour de
 * voltar sozinho numa conta que já o viu. O "refazer" recomeça o passo e deixa
 * `concluido` como está.
 *
 * O servidor não conhece os passos — eles são texto e alvo da interface. Ele
 * guarda onde a conta parou, e só.
 */
export const zTour = z.object({
    passo: z.number().int().min(-1),
    concluido: z.boolean(),
});
//# sourceMappingURL=tour.js.map